import Head from 'next/head';
import React, { useContext, useMemo } from 'react';
import { BookingContext } from '../../../shared/contexts/Booking.context';
import Loader from '../../../shared/loaders/Loader';
import config from '../utils/config';
import useCataloniaForm from './CataloniaForm.hook';

export default function CataloniaForm({ state: guestFormState, actions: guestFormActions }) {
  const { state, actions } = useCataloniaForm({ guestFormState, guestFormActions });
  const iframeHash = useMemo(() => actions.randomHash(), []);
  const { state: bookingContextState } = useContext(BookingContext);

  return (
    <>
      <Head>
        <link
          rel="stylesheet"
          type="text/css"
          href={config.urls(actions.randomHash(), bookingContextState.hotelId)['css']}
          media="screen"
        />
      </Head>

      {state?.scriptsLoaded && (
        <iframe
          id="iframeLogin"
          height="100%"
          width="100%"
          // src={config
          //   .urls(iframeHash, bookingContextState.hotelId)
          //   ['iframe'].replace('{lang}', languageContextState.selectedLanguage || 'es')}
          src={actions.buildIframeUrl(iframeHash)}
          onLoad={e => {
            actions.setiFrameLoaded(true);
          }}
          className={!state?.iframeLoaded && 'hidden'}
        />
      )}
      {!state?.iframeLoaded && <Loader></Loader>}

      <style jsx>{`
        #iframeLogin {
          position: absolute;
          top: 0;
          bottom: 0;
          left: 0;
          width: 100%;
          height: 100%;
          min-height: 50vh;
          border: none;
        }
        .hidden {
          display: none;
        }

        @media (max-height: 800px) {
          #iframeLogin {
            min-height: 580px;
          }
        }
      `}</style>
    </>
  );
}
